import $ from 'jquery';
import Magnific from 'magnific-popup';

export default function magnificSettings() {
    // Translation
    $.extend(true, $.magnificPopup.defaults, {
        tClose: 'X (Esc)',
        tLoading: '...',
        gallery: {
            tPrev: '&#8592;',
            tNext: '&#8594;',
            tCounter: '%curr% / %total%'
        },
        image: {tError: 'x-x'},
        ajax: {tError: 'x-x'}
    });

    // Gallery
    if ($('.gallery').length) {
        $('.gallery').each(function () {
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {enabled: true},
                image: {
                    markup:
                    '<div class="mfp-figure">' +
                    '<div class="mfp-custom-header">' +
                    '<div class="mfp-custom-title">' +
                    '<div class="mfp-title"></div>' +
                    '</div>' +
                    '<div class="mfp-close"></div>' +
                    '</div>' +
                    '<div class="mfp-custom-holder">' +
                    '<div class="mfp-img"></div>' +
                    '</div>' +
                    '<div class="mfp-bottom-bar">' +
                    '<div class="mfp-title"></div>' +
                    '<div class="mfp-counter"></div>' +
                    '</div>' +
                    '</div>',
                    titleSrc: function (item) {
                        if (item.el.parents('figure').find('figcaption').html() === undefined) {
                            return '<small></small>';
                        } else {
                            return item.el.parents('figure').find('figcaption').html();
                        }
                    }
                }
            });
        });
    }

    // Gallery => Revitalization
    if ($('.magnific-gallery').length) {

        var magnificPopupEnabled = true;

        $('.magnific-gallery').each(function () {
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {enabled: true},
                image: {
                    markup:
                    '<div class="mfp-figure mfp-figure-rev">' +
                    '<div class="mfp-custom-header">' +
                    '<div class="mfp-custom-title">' +
                    '</div>' +
                    '<div class="mfp-close"></div>' +
                    '</div>' +
                    '<div class="mfp-custom-holder">' +
                    '<div class="mfp-img"></div>' +
                    '</div>' +
                    '<div class="mfp-bottom-bar">' +
                    '<div class="mfp-title"></div>' +
                    '<div class="mfp-counter"></div>' +
                    '</div>' +
                    '</div>',
                    titleSrc: function (item) {
                        if (item.el.parents('.page-rots-slide-item').find('p').html() === undefined) {
                            return '<small></small>';
                        } else {
                            return item.el.parents('.page-rots-slide-item').find('p').html();
                        }
                    }
                },
                disableOn: function() {
                    if( $(window).width() < 700 ) {
                        return false;
                    } else {
                        return true;
                    }
                }
            });

        });
    }

    $('.magnific-gallery a').on('click', function() {
        if( $(window).width() < 700 ) {
            return false;
        }
    });

    // Single image
    if ($('.single-image').length) {
        $('.single-image').magnificPopup({
            type: 'image',
            image: {
                markup:
                '<div class="mfp-figure">' +
                '<div class="mfp-custom-header">' +
                '<div class="mfp-custom-title">' +
                '<div class="mfp-title"></div>' +
                '</div>' +
                '<div class="mfp-close"></div>' +
                '</div>' +
                '<div class="mfp-custom-holder">' +
                '<div class="mfp-img"></div>' +
                '</div>' +
                '<div class="mfp-bottom-bar">' +
                '<div class="mfp-title"></div>' +
                '<div class="mfp-counter"></div>' +
                '</div>' +
                '</div>',
                titleSrc: function (item) {
                    return item.el.parents('figure').find('figcaption').html();
                }
            }
        });
    }

    // Video
    if ($('.magnific-video').length) {
        $('.magnific-video').magnificPopup({
            type: 'iframe',
            showCloseBtn: true,
            iframe: {
                markup:
                '<div class="mfp-custom-header mfp-custom-header-video">'+
                '<div class="mfp-close"></div>'+
                '</div>'+
                '<div class="mfp-custom-videoholder">'+
                '<div class="mfp-custom-videoholder-inner">'+
                '<div class="mfp-iframe-scaler">'+
                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                '</div>'+
                '</div>'+
                '</div>'
            }
        });
    }

    // Inline
    if ($('.magnific-inline').length) {
        $('.magnific-inline').magnificPopup({
            type: 'inline'
        });
    }
}


// WEBPACK FOOTER //
// ./components/magnific-settings.js